import { useEffect, useSyncExternalStore } from 'react';

import { fetchLocalize, localizeStore } from './localizeStore';
import { EasyshipLocale } from './types';

export const useGetLocalizedMessages = (selectedLocale?: EasyshipLocale) => {
  const localeCode = selectedLocale || 'en';

  const messages = useSyncExternalStore(localizeStore.subscribe, () => localizeStore.getData());

  useEffect(() => {
    fetchLocalize(localeCode);
  }, [localeCode]);

  return {
    messages,
    locale: localeCode,
  };
};
